// extracted by mini-css-extract-plugin
export var button = "ForeignDealNotice-module--button--PCYL2";
export var modalText = "ForeignDealNotice-module--modalText--jftW7";
export var primary = "#06004d";
export var secondary = "#4dafd7";